import { Route, lazyRouteComponent } from "@tanstack/react-router";
import { searchParamsSchema } from "../pages/search-result";
import { rootRoute } from "./root";

export const searchRoute = new Route({
  validateSearch: (search) => searchParamsSchema.parse(search),
  getParentRoute: () => rootRoute,
  path: "/search",
  component: lazyRouteComponent(() => import("../pages/search-result")),
});
